import request from '../request';

export function getHotTopicList(params) {
    return request('/topic/list', {
        method: 'GET',
        params,
    });
}
export function getRecentTopicLabelList() {
    return request('/topic/recentLabels');
}
export function getTopicLabelList() {
    return request('/topic/labels');
}
export function publishTopic(params) {
    if (params.id) {
        return request('/topic/edit', {
            method: 'PUT',
            params,
        });
    } else {
        return request('/topic/publish', {
            method: 'POST',
            params,
        });
    }
}
export function getMyTopicList(params, type) {
    return request(`/topic/${type}`, {
        method: 'GET',
        params,
    });
}
export function getEditTopicDetail(id) {
    return request(`/topic/${id}`);
}
export function getTopicDetail(id) {
    return request(`/topic/detail/${id}`);
}
export function deleteTopic(id) {
    return request(`/topic/delete/${id}`, {
        method: 'DELETE'
    });
}
export function focusTopic(id) {
    return request(`/topic/collect/${id}`, {
        method: 'POST'
    });
}
export function likeTopic(id) {
    return request(`/topic/like/${id}`, {
        method: 'POST'
    });
}

